module.exports = __webpack_public_path__ + "static/media/IMG-ERROR-FORUM.dd47caa7.png";